var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getComponent(_vm.control),{ref:_vm.getRef(_vm.control),tag:"component",attrs:{"question":_vm.question,"required":_vm.required,"options":_vm.options,"description":_vm.description},on:{"validation-update":_vm.handleValidation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }